const BLOCK_TAG_NAMES = new Set([
    'ADDRESS',
    'ARTICLE',
    'ASIDE',
    'BLOCKQUOTE',
    'DIV',
    'FOOTER',
    'H1',
    'H2',
    'H3',
    'H4',
    'H5',
    'H6',
    'HEADER',
    'LI',
    'MAIN',
    'NAV',
    'OL',
    'P',
    'PRE',
    'SECTION',
    'UL',
]);

export const normalizeCellEditorDraft = (text: string) => text.replace(/\r\n?/g, '\n');

const isBlockElement = (node: Node): node is HTMLElement =>
    node.nodeType === Node.ELEMENT_NODE && BLOCK_TAG_NAMES.has((node as HTMLElement).tagName);

const serializeContainer = (container: Node): string => {
    const parts: string[] = [];
    let inlineText = '';
    let hasInlineContent = false;

    const flushInlineText = () => {
        if (!hasInlineContent) return;
        parts.push(inlineText);
        inlineText = '';
        hasInlineContent = false;
    };

    container.childNodes.forEach((child) => {
        if (isBlockElement(child)) {
            flushInlineText();
            const blockText = serializeContainer(child);
            const isEmptyBlockPlaceholder = !child.textContent && blockText === '\n';
            parts.push(isEmptyBlockPlaceholder ? '' : blockText);
            return;
        }

        if (child.nodeType === Node.TEXT_NODE) {
            inlineText += normalizeCellEditorDraft(child.textContent ?? '');
            hasInlineContent = hasInlineContent || !!child.textContent;
            return;
        }

        if (child.nodeType !== Node.ELEMENT_NODE) return;
        if ((child as HTMLElement).tagName === 'BR') {
            inlineText += '\n';
            hasInlineContent = true;
            return;
        }

        const nestedText = serializeContainer(child);
        inlineText += nestedText;
        hasInlineContent = hasInlineContent || nestedText.length > 0;
    });

    flushInlineText();
    return parts.reduce((result, part, index) => {
        if (index === 0) return part;
        return result + (parts[index - 1].endsWith('\n') ? '' : '\n') + part;
    }, '');
};

export const readCellEditorDraft = (editor: HTMLElement) => normalizeCellEditorDraft(serializeContainer(editor));
